// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"796":"03ce5702","904":"d8c7e1cb"}[chunkId] + ".chunk.js";
};